import { marketplace, currency as currencyConfig } from '@sellpy/commons'

const currency = marketplace.CURRENCY[process.env.REGION]

// Set the limit for the price when searching in algolia
export const roundingIncrement = currencyConfig.roundingIncrement(currency)
